import { oroMxCurrencyAssets } from '@/shared/theme/oro-mx-currency-assets';

const publicBase = import.meta.env.BASE_URL.endsWith('/')
  ? import.meta.env.BASE_URL
  : `${import.meta.env.BASE_URL}/`;
const root = `${publicBase}skins/oro-mx-h5/sign-chest`;

/**
 * 源站 Check-in（user_sign_chest）本地化素材。
 * 全部来自 https://web-resource.sibet.game/web/sibet/imgs/new/Check-in/ 的位图，
 * 已下载到 public/skins/oro-mx-h5/sign-chest/，运行时不请求源站 CDN。
 */
export const oroMxSignChestAssets = {
  bg: `${root}/bg.png`,
  cash: [
    `${root}/cash-1.png`,
    `${root}/cash-2.png`,
    `${root}/cash-3.png`,
    `${root}/cash-4.png`,
    `${root}/cash-5.png`,
    `${root}/cash-6.png`,
    `${root}/cash-7.png`,
  ] as const,
  chestSmall: `${root}/chest-s.png`,
  chestMedium: `${root}/chest-m.png`,
  chestLarge: `${root}/chest-l.png`,
  iconCheck: `${root}/icon-check.png`,
  iconLock: `${root}/icon-lock.png`,
  iconVip: `${root}/icon-vip.png`,
  iconVipRibbon: `${root}/icon-vip-ribbon.png`,
  close: `${root}/close.png`,
  titleDecoLeft: `${root}/title-deco-left.png`,
  titleDecoRight: `${root}/title-deco-right.png`,
  rewardBig: `${root}/reward-big.png`,
  currencyBonus: oroMxCurrencyAssets.bonus,
  currencyCash: oroMxCurrencyAssets.cash,
} as const;

export type OroMxSignChestAssetKey = keyof typeof oroMxSignChestAssets;
